import { Avatar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FaEdit, FaEye } from "react-icons/fa";
import { BsTrashFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MuiDataTable from "../../../../../Components/MUIDataTable/MUIDataTable";
import Modal from "../../../../../Components/SiteModal/SiteModal";
import {
  getCurrentUserLeaveApplications,
  indivisualLeavesDeleted,
} from "../../../../../Redux/Actions/LeaveApplications";
import { errorNotify, successNotify } from "../../../../../Utils/toast";
import moment from "moment";

const MyLeaves = ({
  leavesPage,
  setLeavesPage,
  leavesRowsPerPage,
  setLeavesRowsPerPage,
  classes,
  leaveApplications,
  leavesCount,
  onEditLeave,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.currentUser);
  const {
    loading: deletedLeavesLoading,
    deletedLeaves,
    error: deleteError,
  } = useSelector((state) => state.LeavesApplicationDelete);
  const [show, setShow] = useState(false);
  const [leaveId, setLeaveId] = useState("");

  useEffect(() => {
    if (deletedLeaves && deletedLeaves.success) {
      successNotify(deletedLeaves?.message);
      dispatch({ type: "INDIVISUAL_LEAVE_DELETE_RESET" });
      setShow(false);
      dispatch(
        getCurrentUserLeaveApplications(leavesPage, leavesRowsPerPage),
      );
    }
    if (deleteError) {
      errorNotify(deleteError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [deletedLeaves, deleteError, dispatch, leavesPage, leavesRowsPerPage]);

  const handleLeaveID = (id) => {
    setLeaveId(id);
    setShow(true);
  };

  const deleteModal = (
    <Modal
      title="Delete"
      size={"lg"}
      show={show}
      onCloseModal={() => setShow(false)}
    >
      <React.Fragment>
        <p className="modal_Text">Are u sure you want to delete this leave?</p>
        <div className="modal_decision">
          <button
            className="my-1 bg_red"
            onClick={() => dispatch(indivisualLeavesDeleted(leaveId))}
          >
            {deletedLeavesLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Yes"
            )}
          </button>
          <button className="my-1 no_btn" onClick={() => setShow(false)}>
            No
          </button>
        </div>
      </React.Fragment>
    </Modal>
  );

  const leaveManagementColumns = [
    {
      name: "user",
      label: " ",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar src={value?.profile_picture[0]?.fileName} />
            </div>
          );
        },
        download: false,
        print: false,
        display: false,
      },
    },

    {
      name: "_id",
      options: {
        display: false,
      },
    },
    {
      name: "user",
      label: "Employee",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar src={tableMeta.rowData[0].profile_picture[0]?.fileName} />
              <Typography sx={{ pl: 1 }} className="fs-12">
                {value.full_name}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "leave_type",
      label: "Leave Type",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value}
            </Typography>
          );
        },
      },
    },

    {
      name: "start_date",
      label: "From",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value ? moment(value).format("DD-MM-YYYY") : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "end_date",
      label: "To",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value ? moment(value).format("DD-MM-YYYY") : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "numOfDays",
      label: "No Of Days",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "leave_subject",
      label: "Subject",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "leave_category",
      label: "Leave Category",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              sx={{ fontSize: "10px", pl: 1, fontWeight: "600" }}
              className={`${
                value === "paid"
                  ? classes.present
                  : value === "unpaid"
                    ? classes.absent
                    : ""
              }`}
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "line_manager_status",
      label: "HOD Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              sx={{ fontSize: "10px", pl: 1, fontWeight: "600" }}
              className={`${
                value === "approved"
                  ? classes.present
                  : value === "rejected"
                    ? classes.absent
                    : value === "pending"
                      ? classes.halfDay
                      : classes.late
              }`}
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "hr_status",
      label: "HR Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              sx={{ fontSize: "10px", pl: 1, fontWeight: "600" }}
              className={`${
                value === "approved"
                  ? classes.present
                  : value === "rejected"
                    ? classes.absent
                    : value === "pending"
                      ? classes.halfDay
                      : classes.late
              } `}
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const canModify =
            tableMeta.rowData[9] === "pending" &&
            tableMeta.rowData[10] === "pending";

          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                onClick={() =>
                  navigate(
                    `/${user?.user?.role}/leaves/${tableMeta.rowData[1]}`,
                    {
                      state: { update: false },
                    },
                  )
                }
              >
                <FaEye />
              </button>
              {canModify && (
                <button
                  className="edit_btn"
                  onClick={() => onEditLeave(tableMeta.rowData[1])}
                >
                  <FaEdit />
                </button>
              )}
              {canModify && (
                <button
                  className="delete_btn"
                  onClick={() => handleLeaveID(tableMeta.rowData[1])}
                >
                  <BsTrashFill />
                </button>
              )}
            </div>
          );
        },
      },
    },
  ];
  return (
    <Box className="leaves_management_table">
      {deleteModal}
      <MuiDataTable
        title="Departments"
        columns={leaveManagementColumns}
        data={leaveApplications}
        page={leavesPage}
        setPage={setLeavesPage}
        rowsPerPage={leavesRowsPerPage}
        setRowsPerPage={setLeavesRowsPerPage}
        count={leavesCount}
        tableId="my_leaves_table"
      />
    </Box>
  );
};

export default MyLeaves;
